import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEnvironment } from '../context/EnvironmentContext';

export default function EnvironmentSelector() {
  const { environment, setEnvironment } = useEnvironment();
  const { t } = useTranslation();
  const isProd = environment === 'PROD';

  const toggleEnvironment = () => {
    const next = isProd ? 'TEST' : 'PROD';
    setEnvironment(next);
    window.alert(
      t(next === 'TEST'
        ? 'consoleEnvironmentSwitchedToTesting'
        : 'consoleEnvironmentSwitchedToProduction'),
    );
    window.location.reload();
  };

  const hint = isProd
    ? t('consoleEnvironmentProductionMode')
    : t('consoleEnvironmentTestingMode');

  return (
    <button
      type="button"
      className={`environment-control ${isProd ? 'is-prod' : ''}`}
      onClick={toggleEnvironment}
      title={hint}
      aria-label={hint}
    >
      <span className="environment-dot" aria-hidden="true" />{environment}
    </button>
  );
}
